import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { useApolloClient } from "@apollo/client";
import { ChildPropsFromPagination } from "types/commons";
import { GetConnectingVesselsForSelectDocument, GetConnectingVesselsForSelectQuery } from "__generated__/view/connectingVessels/graphql/connectingVessel.queries.generated";

export type ConnectingVesselSelectOption = ChildPropsFromPagination<GetConnectingVesselsForSelectQuery, "connectingVessels">

const ConnectingVesselSelect = ({ ...rest }: Omit<SelectProps<ConnectingVesselSelectOption, false>, "fetchOptions">) => {
	const client = useApolloClient();

	const onFetchOptions = async(params: string, page: number) => {
		try  {
			const currentPage = page - 1;

			const result = await client.query({
				query: GetConnectingVesselsForSelectDocument,
				variables: {
					pagination: {
						page: currentPage,
						size: 5,
					},
					search: {
						name: params,
					},
				},
			});

			return {
				options: result.data?.connectingVessels?.content ?? [],
				totalResults: result.data?.connectingVessels?.totalElements ?? 0,
			};
		} catch (response) {
			return {
				options: [],
				totalResults: 0,
			};
		}
	};

	return (
		<Select
			{...rest}
			fetchOptions={onFetchOptions}
			paginated />
	);
};

export default ConnectingVesselSelect;
